import React from "react";
import BoxContainer from "components/BoxContainer";
import Text from "components/Text";
import Button from "../Button";
import imageResolver from "utils/image-resolver";
const Rating = ({
  achievedstars,
  totalstars,
  Ratinghead,
  ratingsummary,
  ratingcontent,
  cta,
  testimonialhead,
  testimonialdata,
  achievedstarsfigure,
}) => {
  const runCallback = (cb) => {
    return cb();
  };
  return (
    <>
      <BoxContainer className="py-[32px]" background="bg-gradient1">
        <div className="pt-[80px] pb-8 md:w-10/12 m-auto 2xl:max-w-6xl">
          <div className="md:flex md:gap-16">
            <div className="md:w-1/2 mb-12 md:mb-0">
              <Text
                as="h2"
                className="text-yellow font-secondary font-bold text-4xl2 text-center sm:text-left"
              >
                {achievedstars}&nbsp;
                {totalstars}
              </Text>
              <Text
                as="h2"
                className="text-midBlue font-secondary font-bold text-4xl2 text-center sm:text-left"
              >
                {Ratinghead}
              </Text>
              <Text
                as="h2"
                className="text-midBlue text-xl2 leading-loose font-secondary text-center sm:text-left"
              >
                {ratingsummary}
              </Text>

              <div className="flex flex-row gap-3 justify-center sm:justify-start">
                {runCallback(() => {
                  const row = [];
                  for (var i = 0; i < achievedstarsfigure; i++) {
                    row.push(
                      <svg
                        key={i}
                        width="60px"
                        height="60px"
                        className="w-[40px]"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        viewBox="0 0 48 48"
                        enableBackground="new 0 0 48 48"
                      >
                        <polygon
                          fill="#FFCA28"
                          points="24,4 31,17 45,19 35,29 37,44 24,37 11,44 13,29 3,19 17,17 "
                        />
                        <g>
                          <polygon
                            fill="#F9A825"
                            points="24,25 31,17 24,4 &#9;"
                          />
                          <polygon
                            fill="#F9A825"
                            points="45,19 24,25 35,29 &#9;"
                          />
                          <polygon
                            fill="#F9A825"
                            points="37,44 24,25 24,37 &#9;"
                          />
                          <polygon
                            fill="#F9A825"
                            points="13,29 11,44 24,25 &#9;"
                          />
                          <polygon
                            fill="#F9A825"
                            points="3,19 24,25 17,17 &#9;"
                          />
                        </g>
                      </svg>
                    );
                  }
                  return row;
                })}
              </div>
              <Text
                as="div"
                className="text-midBlue font-opensans text-lg leading-8 text-center sm:text-left"
                highlightedText={ratingcontent.highlightWords}
                highlightedColor={ratingcontent.highlightedColor}
              >
                {ratingcontent.description}
              </Text>
              <Button
                title={cta.text}
                href={cta.href}
                className="w-56 h-14 text-lg text-center text-white font-opensans font-medium bg-yellow hover:bg-newOrange-100 transition-colors rounded-full cursor-pointer flex items-center justify-center mt-7 mx-auto sm:mx-0"
              />
            </div>
            <div className="md:w-1/2 mt-4 md:mt-0">
              <Text
                as="p"
                className="text-midBlue font-secondary text-lg font-medium mb-5 text-center sm:text-left"
              >
                {testimonialhead}
              </Text>
              {testimonialdata.map((item, i) => (
                <div
                  key={i}
                  className="bg-white rounded-[14px] p-6 mb-5 shadow-reviewCard"
                >
                  <a href={item.href}>
                    <Text
                      as="h3"
                      className="text-darkBlue font-opensans text-lg font-bold"
                    >
                      "{item.content}"
                    </Text>
                    <div className="flex items-center mt-6">
                      <div>
                        <Text
                          as="p"
                          className="text-lightBluegray font-opensans text-lg font-semibold"
                        >
                          {item.name}
                        </Text>
                      </div>
                      <div className="ml-auto">
                        {imageResolver(item.title, item.icon, item.className)}
                      </div>
                    </div>
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
      </BoxContainer>
    </>
  );
};

export default Rating;
